import { render, staticRenderFns } from "./ContactFormSimple.vue?vue&type=template&id=dabcb496&"
import script from "./ContactFormSimple.vue?vue&type=script&lang=js&"
export * from "./ContactFormSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports